module.exports = __webpack_public_path__ + "img/icon_api@2x.0eeca29d.png";